//------------------------------------------------
//
//	ReU: Lenis Smooth Scroll コア
//	WP独自のドロワー/モーダル/言語/画像モーダルのコードは含まない（Dawnのネイティブ UI を使用）。
//
//------------------------------------------------
let lenis;

// マスター killswitch
const ENABLE_SMOOTH_SCROLL = true;
const ENABLE_LENIS_ON_MOBILE = false;

// DOMContentLoaded後にLenisを初期化
document.addEventListener('DOMContentLoaded', function () {
    const isMobile = window.matchMedia('(max-width: 1024px)').matches;
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const isLenisDisabled = new URLSearchParams(window.location.search).has('nolenis');
    const shouldInitLenis = ENABLE_SMOOTH_SCROLL
        && !isLenisDisabled
        && !prefersReducedMotion
        && (!isMobile || ENABLE_LENIS_ON_MOBILE);

    if (shouldInitLenis) {
        lenis = new Lenis({
            wrapper           : document.documentElement, // スクロールコンテナ (html要素)
            content           : document.body,
            duration          : 1.2,
            easing            : (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
            orientation       : 'vertical',
            gestureOrientation: 'vertical',
            smoothWheel       : true,
            smoothTouch       : false,
            wheelMultiplier   : 1,
            touchMultiplier   : 2,
            infinite          : false,
            autoResize        : true,
            autoRaf           : true,
            prevent           : (node) => node instanceof Element
                && node.closest('#GosubAccountModalContainer, .jdgm-modal') !== null
        });

        // デバッグ・外部スクリプトからの参照用（実機コンソールで lenis を触れるように）
        window.lenis = lenis;

        //------------------------------------------------
        //
        //	Dawnドロワー/モーダル連携
        //	document.body の class / style 変化を監視し、overflow-hidden 系クラスまたは
        //	computed overflow-y が hidden / clip なら Lenis を止め、無ければ再開する。
        //	cart-drawer / menu-drawer / modal-dialog / quick-add / predictive-search を一括カバー。
        //	Judge.me のモーダルは class でなく body の style に overflow: hidden を直接書くため、style も見る。
        //
        //------------------------------------------------
        const syncLenisWithBodyScrollLock = () => {
            const hasOverflowHiddenClass = Array.prototype.some.call(
                document.body.classList,
                (className) => className.indexOf('overflow-hidden') === 0
            );
            const overflowY = window.getComputedStyle(document.body).overflowY;
            const isLocked = hasOverflowHiddenClass || overflowY === 'hidden' || overflowY === 'clip';
            if (isLocked) {
                lenis.stop();
            } else {
                lenis.start();
            }
        };

        new MutationObserver(syncLenisWithBodyScrollLock).observe(document.body, {
            attributes     : true,
            attributeFilter: ['class', 'style']
        });

        // 初期状態も一度チェック（読み込み時点で既にロック中のケースを保険）
        syncLenisWithBodyScrollLock();

        // スクロール方向検出・クラス管理
        let lastScrollTop = 0;
        let isFirstScroll = true;

        lenis.on('scroll', (instance) => {
            const body = document.body;
            const currentScrollTop = instance.scroll;

            // .running は「目的地」(targetScroll) で判定する。
            // instance.scroll はスムーススクロールでアニメーション中の現在位置のため、
            // トップへ戻る際にイージングの尻尾で 0 への収束が遅れ、クラスの解除にラグが出る。
            // 目的地で判定すれば操作した瞬間に切り替わり、ラグが解消される。
            const targetScrollTop = (typeof instance.targetScroll === 'number')
                ? instance.targetScroll
                : currentScrollTop;

            // スクロール量が1px以上の場合、.runningクラスを追加
            if (Math.abs(targetScrollTop) >= 1) {
                body.classList.add('running');
            } else {
                body.classList.remove('running');
            }

            // 初回スクロール時の処理
            if (isFirstScroll && currentScrollTop > 0) {
                body.classList.add('down');
                body.classList.remove('up');
                isFirstScroll = false;
            }
            // 通常のスクロール処理
            else if (currentScrollTop > lastScrollTop) {
                body.classList.add('down');
                body.classList.remove('up');
            } else if (currentScrollTop < lastScrollTop) {
                body.classList.add('up');
                body.classList.remove('down');
            }

            // 最上部での処理
            if (currentScrollTop <= 0) {
                body.classList.remove('down', 'up');
                isFirstScroll = true;
            }

            lastScrollTop = currentScrollTop;

            // reloadedクラスを削除（最初のスクロール時に一度だけ実行）
            body.classList.remove('reloaded');
        });

    } else {
        // Lenis無効時（モバイル／reduced-motion／killswitch off）：ネイティブscrollイベントで同等のクラス管理を行う
        let lastScrollTop = 0;
        let isFirstScroll = true;

        window.addEventListener('scroll', function () {
            const body = document.body;
            const currentScrollTop = window.scrollY;

            // スクロール量が1px以上の場合、.runningクラスを追加
            if (Math.abs(currentScrollTop) >= 1) {
                body.classList.add('running');
            } else {
                body.classList.remove('running');
            }

            // 初回スクロール時の処理
            if (isFirstScroll && currentScrollTop > 0) {
                body.classList.add('down');
                body.classList.remove('up');
                isFirstScroll = false;
            }
            // 通常のスクロール処理
            else if (currentScrollTop > lastScrollTop) {
                body.classList.add('down');
                body.classList.remove('up');
            } else if (currentScrollTop < lastScrollTop) {
                body.classList.add('up');
                body.classList.remove('down');
            }

            // 最上部での処理
            if (currentScrollTop <= 0) {
                body.classList.remove('down', 'up');
                isFirstScroll = true;
            }

            lastScrollTop = currentScrollTop;

            // reloadedクラスを削除（最初のスクロール時に一度だけ実行）
            body.classList.remove('reloaded');
        });
    }

    //------------------------------------------------
    //
    //  横スクロール抑制
    //  Lenis は縦方向しか管理しないため、マジックマウス等の横方向ホイール/
    //  スワイプによるネイティブ横スクロール（＝ページ全体が左右に動く）が残る。
    //  横方向が主成分のホイールを preventDefault で抑止する。
    //  ただし overflow-x: scroll/auto を持ち実際に横スクロール可能な祖先の
    //  内部では従来通り許可する。
    //------------------------------------------------
    window.addEventListener('wheel', function (e) {
        // 縦方向が主成分なら何もしない（縦スクロールは Lenis に委譲）
        if (Math.abs(e.deltaX) <= Math.abs(e.deltaY)) return;

        // 横スクロール可能な祖先を探索。見つかれば許可。
        let el = (e.target instanceof Element) ? e.target : null;
        while (el && el !== document.body && el !== document.documentElement) {
            if (el.scrollWidth > el.clientWidth) {
                const ox = getComputedStyle(el).overflowX;
                if (ox === 'auto' || ox === 'scroll' || ox === 'overlay') {
                    return; // 明示的な横スクロールコンテナ → 許可
                }
            }
            el = el.parentElement;
        }

        // それ以外の横方向ジェスチャーはページの横スクロールを抑止
        e.preventDefault();
    }, { passive: false });
});

//
//	Lenisを使ったページ内スムーズスクロール
//	https://greensock.com/forums/topic/26339-anchor-link-to-end-of-elements-position-while-using-scrolltrigger/
//

// CSS変数の値をピクセル値に変換する関数
function getCSSVariablePixelValue(cssVarName) {
    // ダミー要素を作成してCSS変数の計算値を取得
    const dummy = document.createElement('div');
    dummy.style.position = 'absolute';
    dummy.style.visibility = 'hidden';
    dummy.style.height = `var(${cssVarName})`;
    document.body.appendChild(dummy);

    // 計算されたピクセル値を取得
    const computedValue = window.getComputedStyle(dummy).height;
    const pixelValue = parseFloat(computedValue) || 0;

    // ダミー要素を削除
    document.body.removeChild(dummy);

    return pixelValue;
}

// ハッシュリンクにイベントリスナーを登録（DOM読み込み完了後）
document.addEventListener('DOMContentLoaded', function() {
    var linksWithHash = document.querySelectorAll('a[href*=\\#]:not([href=\\#])')
    linksWithHash.forEach((link) => {
        link.addEventListener('click', handleHashLinkClick);
    });
});

// スクロールoffset値を取得する関数（CSS変数から）
function getScrollOffset(linkElement) {
    // data-offset-var属性でCSS変数を参照
    const cssVarName = linkElement.getAttribute('data-offset-var');
    if (cssVarName) {
        return getCSSVariablePixelValue(cssVarName);
    }

    // 既定値: 浮遊ヘッダー分として --header-height があればその値、無ければ0
    return getCSSVariablePixelValue('--header-height');
}

// ハッシュリンククリック時の処理（同一ページ・別ページ両対応）
function handleHashLinkClick(event) {
    const link = this;
    const isSamePage = location.pathname.replace(/^\//, '') == link.pathname.replace(/^\//, '') && location.hostname == link.hostname;

    if (isSamePage) {
        // 同一ページ内リンク：即座にスクロール
        event.preventDefault();
        const target = document.querySelector(link.hash);
        if (target) {
            const offset = getScrollOffset(link);
            scrollToTarget(target, offset);
        }
    } else {
        // 別ページへのリンク：offset情報をsessionStorageに保存
        const offset = getScrollOffset(link);
        if (offset !== 0 || link.hasAttribute('data-offset-var')) {
            const scrollData = {
                hash: link.hash,
                offset: offset,
                cssVarName: link.getAttribute('data-offset-var')
            };
            sessionStorage.setItem('scrollToHashOffset', JSON.stringify(scrollData));
        }
    }
}

// ターゲット要素へスクロール実行
function scrollToTarget(target, offset) {
    if (lenis) {
        lenis.scrollTo(target, {
            offset: -offset, // 負の値にすることでヘッダー分上にスクロール
            duration: 1.2,
            easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t))
        });
    } else {
        const targetPosition = target.getBoundingClientRect().top + window.pageYOffset - offset;
        window.scrollTo({ top: targetPosition, behavior: 'smooth' });
    }
}

// ページロード時：URLにハッシュがある場合の処理
window.addEventListener('load', function() {
    const hash = window.location.hash;
    if (!hash) return;

    // sessionStorageから保存されたoffset情報を取得
    const savedData = sessionStorage.getItem('scrollToHashOffset');
    let offset = 0;

    if (savedData) {
        try {
            const scrollData = JSON.parse(savedData);
            if (scrollData.hash === hash) {
                // CSS変数から計算
                if (scrollData.cssVarName) {
                    offset = getCSSVariablePixelValue(scrollData.cssVarName);
                }
                // 直接保存されたoffset値
                else {
                    offset = scrollData.offset || 0;
                }
            }
            // 使用後は削除
            sessionStorage.removeItem('scrollToHashOffset');
        } catch (e) {
            sessionStorage.removeItem('scrollToHashOffset');
        }
    }

    // ターゲット要素へスクロール
    const target = document.querySelector(hash);
    if (target) {
        // DOM描画完了後にスクロール実行（少し遅延させる）
        setTimeout(function() {
            scrollToTarget(target, offset);
        }, 100);
    }
});
